﻿(function($) {

	let footerTriggered = false
	/*
	 * Barba
	 */
	//barba.use(barbaCss);
	barba.hooks.enter((data) => {

		window.scrollTo(0, 0);

	});

	barba.init({
		debug:false,
		timeout: 5000,
		prevent: ({ el }) => el.classList && el.classList.contains('no-barba'),
		transitions: [{
			beforeLeave(data) {

				return new Promise((resolve, reject) => {

					/*- Add class to enter transition -*/
					document.querySelector("#page-transition").classList.add("enter")


					document.querySelector("#page-transition").addEventListener("animationend", () => {

						if( ! data.next.url.path.includes("/services/")){
							document.documentElement.style.setProperty('--main-color', "68, 77, 250")
						}

						if(navTrigger.classList.contains('active')){

							document.querySelector("#megamenu").classList.add("no-transition")

							for(const elem of document.querySelectorAll('body, #megamenu, #header, #main, #nav-trigger, .social-links')){
								elem.classList.remove('active')
							}

							resolve()

						}else{

							resolve()

						}
					})

				});

			},
			enter(data) {

				/*- Add class to exit transition-*/
				document.querySelector("#page-transition").classList.add("leave")

				document.querySelector("#page-transition").addEventListener("animationend", () => {
					document.querySelector("#page-transition").classList.remove("leave", "enter")

					const hexToRgb = (hex) => {
						const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
						return result ? parseInt(result[1], 16) + ", " + parseInt(result[2], 16) + ", " + parseInt(result[3], 16) : null
					}

					if(data.next.url.path.includes("/services/")){

						if(document.querySelector("#service-color") != null){

							document.documentElement.style.setProperty('--main-color', hexToRgb(document.querySelector("#service-color").getAttribute("data-color")))

						}

					}else{

						document.documentElement.style.setProperty('--main-color', "68, 77, 250")
					}
				})

				console.log(data.next.url.path)

				if( data.next.url.path.includes("/contact") ){

					if(data.next.url.hash != null){

						setTimeout(function () {
							$('html, body').animate({
								scrollTop: $('#' + data.next.url.hash).offset().top
							}, 1000);

						}, 500);

						console.log("initFooter from anchor")

						initFormFooter(true)
						document.querySelector("#footer .form-container").classList.remove("hidden")

					}else{
						document.querySelector("#footer .form-container").classList.remove("hidden")
						initFormFooter();
					}

				}else{
					//console.log("not contact page")
					document.querySelector("#footer .form-container").classList.add("hidden")
				}

				/*- Ajout une classe au body quand on est dans la page -*/

				if(data.next.url.path == "/carriere/" || data.next.url.path.includes("offre-emploi") || window.location.href.includes("notre-equipe")){
					document.querySelector("body").classList.add("page-form-carriere")
				}else if( data.next.url.path.includes("demande-de-soutien") || data.next.url.path.includes("loi-25-septembre")){
					document.querySelector("body").classList.add("no-banner")
				}else{
					document.querySelector("body").classList.remove("page-form-carriere", "no-banner")
				}

				/*- Retirer la classe d'animation et reload les fonctions JS -*/
				setTimeout(function(){
					libs_init()
					document.querySelector("#megamenu").classList.remove("no-transition")
				}, 0);
			}
		}]
	});


	function libs_init()
	{
		const urlsToIgnore = window.barba_ignore_urls


		for(const item in urlsToIgnore ){
			const linksToDisable = document.querySelectorAll("a[href='" + urlsToIgnore[item]["url"] + "']");

			linksToDisable?.forEach((el, index) => {
				el.classList.add("no-barba")
			})
			//console.log(`${urlsToIgnore[item]["url"]}`);
		}

		AOS.init({
			once: true
		});


		document.querySelectorAll("a").forEach((el, index) => {
			if(el.getAttribute("href")?.includes(window.upload_dir_url))
				el.setAttribute("data-barba-prevent","self")
		});

		/*
		 * Sticky
		 */

		if(window.innerWidth > 991 && document.querySelector(".sticky-wrapper")){
			var sidebar = new StickySidebar('.sticky-wrapper', {
				containerSelector: '.blog-post',
				innerWrapperSelector: '.sticky',
				topSpacing: 200,
				bottomSpacing: 50
			});
		}

		/*- Couleur de page -*/

		const hexToRgb = (hex) => {
			const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)

			return result ? parseInt(result[1], 16) + ", " + parseInt(result[2], 16) + ", " + parseInt(result[3], 16) : null
		}

		if(window.service_color != null){
			document.documentElement.style.setProperty('--main-color', hexToRgb(window.service_color))
		}

		const footer_form_class = (e) => {

			const page = document.querySelector("html");
			let scroll = page?.scrollTop;
			const footerHeight = document.querySelector("#footer").offsetHeight

			//console.log((page.offsetHeight - window.innerHeight - footerHeight) + "/" + scroll)

			if((page.offsetHeight - window.innerHeight - footerHeight) <= scroll){

				document.querySelector("body > .social-links").classList.add("active")

			}else{

				document.querySelector("body > .social-links").classList.remove("active")

			}

		}

		window.addEventListener("wheel", footer_form_class)

		/*
		* Texte typing
		*/

		$('.banner .text-change').each(function(){
			let text_holder = "";
			let new_val = $(this).data('new-values');

			$(this).parent().addClass("has-text-change")

			for( const elem of new_val){
				if(text_holder.length < elem.length){
					text_holder = elem
				}
			}

			$(this).text(text_holder)
			$(this).parent().append("<div class='text-change-copy' data-nosnippet aria-hidden='true'>" + $(this).parent().html() + "</div>")

			let old_val = $(this).data('old-value');
			let delay = $(this).data('delay');
			let start_delay = $(this).data('start-delay') ? $(this).data('start-delay') : 0;
			let cursor = $(this).data('cursor');
			let this_dom = $(this).parent().find(".text-change-copy").find(".text-change")[0];
			let this_jquery = $(this);

			let strings = new_val;
			strings.unshift(old_val);

			new Typed(this_dom,
				{
					strings: strings,
					typeSpeed: 50,
					backSpeed: 25,
					backDelay: delay,
					startDelay: start_delay,
					loop: false,
					showCursor: cursor == "true" ? true : false,
					onComplete: function(self) {
						this_jquery.siblings('.typed-cursor').addClass('done');
					}
				}
			);
		});

		/*
		 Taxonomy filtering
		 */
		$('.tax-filters a').click(function(e){
			e.preventDefault();

			let _this = $(this);
			$('.tax-filters a').removeClass('active');

			let taxonomy = $(this).data('taxonomy');
			let term_id = $(this).data('term-id');
			let post_type = $(this).data('post-type');
			let parent_cat = $(this).data('parent-cat');
			let href = $(this).attr('href');

			let data = {
				'action': 'ajax_filter_taxonomy',
				'taxonomy':  taxonomy,
				'term_id': term_id,
				'post_type': post_type,
				'parent_cat' : parent_cat
			};

			$.post(window.ajax_url, data, function(r){

				$('.injector').html(r.data);
				_this.addClass('active');
				$('.pagination').remove();
				window.history.replaceState({}, '', href);

			});
		});

		$('.category-filter-dropdown').change(function(){
			$('.tax-filters a#tax-' + $(this).val()).click()
		})


		/*
		* Shooting squares
		*/

		let squaresBanner = document.querySelectorAll(".shooting-square.onLoad")
		squaresBanner.forEach((el, index) =>{
			window.setTimeout(() => {
				el.classList.add("enter")
			}, 500+index*250)
		});




		/*
		*  Detect slice in viewport
		*/

		let slices = document.querySelectorAll(".slice")

		const isInViewport = (entries) =>{
			entries.forEach(el => {
				if (el && el.isIntersecting && !el.target.classList.contains('active')) {
					el.target.classList.add('active')

					if(!el.target.id)
						return

					$('#' + el.target.id + " .text-change").each(function(){

						let text_holder = "";
						let new_val = $(this).data('new-values');

						$(this).parent().addClass("has-text-change")

						for( const elem of new_val){
							if(text_holder.length < elem.length){
								text_holder = elem
							}
						}

						$(this).text(text_holder)
						$(this).parent().append("<div class='text-change-copy' data-nosnippet aria-hidden='true'>" + $(this).parent().html() + "</div>")

						let old_val = $(this).data('old-value');

						let delay = $(this).data('delay');
						let start_delay = $(this).data('start-delay') ? $(this).data('start-delay') : 0;
						let cursor = $(this).data('cursor');
						let this_dom = $(this).parent().find(".text-change-copy").find(".text-change")[0];
						let this_jquery = $(this);

						let strings = new_val;
						strings.unshift(old_val);

						new Typed(this_dom,
							{
								strings: strings,
								typeSpeed: 50,
								backSpeed: 25,
								backDelay: delay,
								startDelay: start_delay,
								loop: false,
								showCursor: cursor == "true" ? true : false
							}
						);
					})
				}
			})
		}

		let options = {
			root: null,
			rootMargin: '0px',
			threshold: 0.3,
		}

		const observer = new IntersectionObserver(isInViewport, options);

		for(var slice of slices){
			observer.observe(slice);
		}



		/*
		* Animation du cube en accueil
		*/

		let cube = document.querySelector('.cube')
		let radioGroup = document.querySelector('.color-picker-container')
		let currentClass = ''

		const changeSide = () => {
			const checkedRadio = radioGroup.querySelector(':checked')
			const showClass = 'show-' + checkedRadio.value

			document.documentElement.style.setProperty('--main-color', checkedRadio.getAttribute("data-rgb"))

			document.querySelector("body").classList.remove( currentClass )
			document.querySelector("body").classList.add( showClass )

			cube.classList.remove( currentClass )
			cube.classList.add( showClass )
			currentClass = showClass
		}
		const initCube = () => {
			cube.classList.add( 'show-' + radioGroup.querySelector(':checked').value )
			currentClass = 'show-' + radioGroup.querySelector(':checked').value
		}

		if(radioGroup){
			// set initial side
			initCube()
		}




		/*- Custom fancybox close -*/

		let closeFancyboxTrigger = document.querySelectorAll('#close-fancybox, .nom-client a')
		const closeFancybox = (e) => {
			document.querySelector(".fancybox-close-small")?.click()
		}




		/*- parallax membre équipe -*/
		const teamMemberBlocks = document.querySelectorAll(".floating-elems")

		// Magic happens here
		const parallax = (e) => {
			let _w = e.currentTarget.clientWidth
			let _h = e.currentTarget.clientHeight
			let _mouseX = ((e.clientX - e.currentTarget.getBoundingClientRect().left) / _w * 100) - 50
			let _mouseY = ((e.clientY - e.currentTarget.getBoundingClientRect().top) / _h * 100) - 50
			let _modX = 0
			let _modY = -10
			let _depth1 = `${_modX - (_mouseX) * 0.10}px ${_modY - (_mouseY) * 0.10}px`
			let _depth2 = `${_modX - (_mouseX) * 0.20}px ${_modY - (_mouseY) * 0.20}px`
			let _depth3 = `${_modX - (_mouseX) * 0.40}px ${_modY - (_mouseY) * 0.40}px`
			let _depth4 = `${_modX - (_mouseX) * 0.60}px ${_modY - (_mouseY) * 0.60}px`

			let x = `${_depth4}, ${_depth3}, ${_depth2}, ${_depth1}`
			//console.log(_mouseX)
			//console.log(_mouseY)

			e.currentTarget.style.backgroundPosition = x
		}

		teamMemberBlocks.forEach((el, index) => {
			el.addEventListener("mousemove", parallax)
		})


		/*
		 * Ajax team member


		$('.team-member-block').click(function(){
			let team_member_id = $(this).data('id');

			let data = {
				'action': 'ajax_view_team_block',
				'team_member_id': team_member_id
			}

			$.post(window.ajax_url, data, function(r){
				if(r.success){
					$.fancybox.open(r.data)
					closeFancyboxTrigger = document.querySelector('#close-fancybox')
					closeFancyboxTrigger.addEventListener("click", closeFancybox)
				}

			});
		});*/




		/*- Horizontal scrolling - Services -*/

		const scrollContainer = document.querySelector(".service-steps-slider");

		if((window.innerHeight < 900 || window.innerWidth < 1024) && scrollContainer != null){

			scrollContainer?.classList.add("slider")

		}else{

			scrollContainer?.classList.add("scrollable")

			scrollContainer?.addEventListener("wheel", (evt) => {

				let viewportOffset = scrollContainer.getBoundingClientRect()
				let offsetTop = viewportOffset.top

				if(offsetTop <= 500){
					let scrollStep = 20

					if(evt.deltaY < 0){
						scrollStep = -20
					}

					if((scrollContainer.scrollLeft < (scrollContainer.clientWidth * (scrollContainer.childElementCount-1)) && evt.wheelDeltaY < 0) || (scrollContainer.scrollLeft > 0 && evt.wheelDeltaY > 0)){
						evt.preventDefault()
					}

					scrollContainer.scrollLeft += scrollStep*4
				}

			});

		}



		/*
		* Sliders
		*/

		const sliders = document.querySelectorAll(".slider")

		sliders?.forEach((el, index) => {

			const slider = tns({
				mode:el.getAttribute("data-mode") ? el.getAttribute("data-mode") : "carousel",
				container: el,
				items: el.getAttribute("data-slide-to-show") ? el.getAttribute("data-slide-to-show") : "1",
				slideBy: 1,
				autoplay: el.getAttribute("data-autoplay") ? true : false,
				center: el.getAttribute("data-center-mode") ? true : false,
				gutter:50,
				loop:true,
				controls:true,
				mouseDrag:true,
				controlsContainer: el.getAttribute("data-controls") ? el.getAttribute("data-controls") : ".slider-controls",
				prevButton:document.querySelector(el.getAttribute("data-controls") ? el.getAttribute("data-controls") + " .tns-prev" : ".slider-controls" + " .tns-prev"),
				nextButton:document.querySelector(el.getAttribute("data-controls") ? el.getAttribute("data-controls") + " .tns-next" : ".slider-controls" + " .tns-next"),
				nav:false,
				responsive: {
					1199: {
						gutter: 30
					},
					769: {
						gutter: 30,
						items: el.getAttribute("data-slide-to-show") ? el.getAttribute("data-slide-to-show") : "1"
					},768: {
						gutter: 30,
						items: el.getAttribute("data-slide-to-show") < 2 ? el.getAttribute("data-slide-to-show") : 2
					},
					641: {
						items: el.getAttribute("data-slide-to-show") < 2 ? el.getAttribute("data-slide-to-show") : 2
					},
					320: {
						center:false,
						items: el.getAttribute("data-slide-to-show-mobile") ? el.getAttribute("data-slide-to-show-mobile") : 1
					}
				}

			})

			slider.events.on('indexChanged', () => {
				AOS.refresh()
			})

		})




		/*- Bouton read more - Services -*/

		const readMoreBtns = document.querySelectorAll(".read-more")

		const showMoreText = (evt) => {
			const _this = evt.currentTarget
			_this.parentElement.classList.add("open")
		}

		readMoreBtns?.forEach((el, index) => {

			el.addEventListener("click", showMoreText)

		})

		if(window.innerWidth <= 1024){
			//console.log("ready to slide")
			const serviceSliderNav = document.querySelector("#service-slider-controls")

			serviceSliderNav?.addEventListener("click", (evt) => {
				//console.log("scrolling up")
				document.querySelector('.service-steps').scrollIntoView({ behavior: 'smooth' });
			})

		}



		/*
		 * Toggle header classes
		 */
		const header_class = () => {
			const page = document.querySelector("html");
			const header = document.querySelector("#header");
			let scroll = page?.scrollTop;

			if (scroll >= 50 ){
				header?.classList.add('shrink');
			} else {
				header?.classList.remove('shrink');
			}
		}

		const googleMaps = document.querySelectorAll(".google-map");

		googleMaps.forEach((el, index) => {
			let map = initMap( el );
		})



		/*
		 * Google maps
		 */

		function initMap( el ) {

			// Find marker elements within map.
			var markers = el.querySelectorAll('.marker');

			// Create gerenic map.
			var mapArgs = {
				zoom        : parseInt(el.getAttribute('data-zoom')) || 16,
				mapTypeId   : google.maps.MapTypeId.ROADMAP,
				styles		: window.google_maps_styles,
				disableDefaultUI: true,
			};
			var map = new google.maps.Map( el, mapArgs );

			// Add markers.
			map.markers = [];
			markers.forEach((marker, index) =>{
				initMarker( marker, map );
			})

			// Center map based on markers.
			centerMap( map );

			// Return map instance.
			return map;
		}
		/**
		 * initMarker
		 *
		 * Creates a marker for the given jQuery element and map.
		 *
		 * @date    22/10/19
		 * @since   5.8.6
		 *
		 * @param   jQuery $el The jQuery element.
		 * @param   object The map instance.
		 * @return  object The marker instance.
		 */
		function initMarker( marker, map ) {

			// Get position from marker.
			var lat = marker.getAttribute('data-lat');
			var lng = marker.getAttribute('data-lng');
			var latLng = {
				lat: parseFloat( lat ),
				lng: parseFloat( lng )
			};

			// Create marker instance.
			var newMarker = new google.maps.Marker({
				position : latLng,
				map: map,
				icon: window.google_maps_marker_img_url
			});

			// Append to reference for later use.
			map.markers.push( newMarker );


			// If marker contains HTML, add it to an infoWindow.
			if( marker.innerHTML ){

				// Create info window.
				var infowindow = new google.maps.InfoWindow({
					content: marker.innerHTML
				});

				// Show info window when marker is clicked.
				google.maps.event.addListener(marker, 'click', function() {
					infowindow.open( map, marker );
				});
			}

		}

		/**
		 * centerMap
		 *
		 * Centers the map showing all markers in view.
		 *
		 * @date    22/10/19
		 * @since   5.8.6
		 *
		 * @param   object The map instance.
		 * @return  void
		 */
		function centerMap( map ) {

			// Create map boundaries from all map markers.
			var bounds = new google.maps.LatLngBounds();
			map.markers.forEach(function( marker ){
				bounds.extend({
					lat: marker.position.lat(),
					lng: marker.position.lng()
				});
			});

			// Case: Single marker.
			if( map.markers.length == 1 ){
				map.setCenter( bounds.getCenter() );

				// Case: Multiple markers.
			} else{
				map.fitBounds( bounds );
			}
		}

		/*- fin google map -*/


		/*
		* Event listener
		*/

		document.querySelector("#page-transition").addEventListener("animationend", (e) => {
			e.currentTarget.classList.remove("play")
		})

		radioGroup?.addEventListener( 'change', changeSide )

		$('.color-square').mouseover(function(){
			$('.color-square').removeClass("active")
			$(this).addClass('active')
			$(this).click()
		})

		closeFancyboxTrigger?.forEach((el, index) => {
			el.addEventListener("click", closeFancybox)
		})

		window.addEventListener("scroll", header_class)

	}

	libs_init();


	const initFormFooter = (isAnchor) => {

		/*
		* footer form reveal
		*/
		let formStep = 1

		const footer_form_trigger = () => {

			const page = document.querySelector("html");
			let scroll = page?.scrollTop;
			const footerHeight = document.querySelector("#footer").offsetHeight

			if(footerTriggered)
				return

			console.log( scroll + " / " + (page.offsetHeight - window.innerHeight - 900) )

			if((page.offsetHeight - window.innerHeight - 900) <= scroll || isAnchor || window.innerWidth <= 1024){
				footerTriggered = true
				startTyping(formStep)

			}

		}

		/*
		* Footer form texte typing
		*/

		var errorForm = false

		$('#submit-form').click(function(e){
			e.preventDefault();
			errorForm = false

			$('.footer-form input.visible, .footer-form textarea.visible, .footer-form select.visible, .footer-form .required').each(function(index){

				if($(this).val() == ""){

					errorForm = true
					$(this).addClass("error")

				}else{

					$(this).removeClass("error")

				}

				//Valide le foramt l'adresse courriel

				if($(this).attr("type") == "email"){

					if( !validateEmail( $(this).val() ) ){

						errorForm = true
						$(this).addClass("error")

					}else{

						$(this).removeClass("error")

					}

				}

				//Valide le foramt de l'URL du site web

				if($(this).hasClass("url")){

					if( !validateURL( $(this).val() ) ){

						errorForm = true
						$(this).addClass("error")

					}else{

						$(this).removeClass("error")

					}

				}
			})

			if( ! errorForm ){

				$('#error-message').hide()

				handle_form( $('.footer-form'), function(data){
					$('.footer-form').remove()
					$('#succes-message *').remove()
					$('#succes-message').append(data.data)
					$('#succes-message').show()

				})

			}else{

				$('#error-message').show()

			}

		})

		$('.footer-form').keypress(function(e){
			//console.log(e.keyCode)

			if(e.keyCode == 13)
				e.preventDefault();

		});

		let lastStep = 6
		let intentTimer

		const ddSujet = document.querySelector("#ddSujet")
		const ddPosteDispo = document.querySelector("#ddPosteDispo")
		const ddPostePigiste = document.querySelector("#ddPostePigiste")
		const ddService = document.querySelector("#ddService")
		const ddContact = document.querySelector("#ddContact")

		const tt1 = document.querySelector("#typedText1")
		const tt2 = document.querySelector("#typedText2")
		const tt3 = document.querySelector("#typedText3")

		const startTyping = (pStep) => {

			//console.log(pStep)

			let this_dom = $(this)[0];
			let elem = document.querySelector('#footer .tt-' + pStep);

			new Typed(elem,
				{
					strings: [elem.getAttribute('data-new-value')],
					typeSpeed: 15,
					backSpeed: 25,
					showCursor: false,
					loop: false,
					onComplete: function(self) {
						if(pStep == lastStep)
							document.querySelector(".block-submit").style.setProperty("display", "block");

						//console.log(document.querySelector("." + elem.getAttribute("data-tt-input")))
						document.querySelector("." + elem.getAttribute("data-tt-input")).classList.add("visible")



						if(pStep == 4){
							document.querySelector(".form-step-5").style.setProperty("display", "block");
							document.querySelector(".form-step-5").classList.add("visible")
							startTyping(5)
							formStep = 6;
						}
					}
				}
			);
		}

		const formNextStep = () => {
			//console.log(formStep)
			if(formStep == lastStep){

				document.querySelector(".block-submit").style.setProperty("display", "block")
				document.querySelector(".tt-submit").classList.add("visible")

			}else{

				formStep++
				document.querySelector(".form-step-" + formStep)?.style.setProperty("display", "block")
				startTyping(formStep)
			}


			//console.log(formStep)
		}

		const resetForm = () => {

			formStep = 1;
			document.querySelectorAll(".form-step-2, .form-step-3, .form-step-4, .form-step-5, .form-step-7, .form-step-8")?.forEach((el, index)=> {
				el.style.setProperty("display", "none");
			})

			document.querySelector(".form-step-6").classList.remove("visible")

			document.querySelector(".tt-input-2")?.classList.remove('visible')
			document.querySelector(".tt-input-2")?.classList.remove("tt-input-2")

			document.querySelector(".tt-submit").classList.remove("visible")
			document.querySelector(".tt-input-4").value=""

			tt1.setAttribute("data-new-value", "")
			tt1.innerHTML = ""
			tt2.setAttribute("data-new-value", "")
			tt2.innerHTML = ""
			tt3.innerHTML = ""

		}

		const validateEmail = (email) => {
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(email).toLowerCase());
		}

		const validateURL = (str) => {
			var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
				'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
				'((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
				'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
				'(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
				'(\\#[-a-z\\d_]*)?$','i'); // fragment locator
			return !!pattern.test(str);
		}

		ddSujet?.addEventListener("change", (e) => {

			if(ddSujet.value === "")
				return

			if(formStep > 1){
				resetForm()
			}

			lastStep = 6

			if(ddSujet.value === "Faire appel à vos services"){

				//Texts
				tt1.setAttribute("data-new-value", "pour un projet de")
				tt2.setAttribute("data-new-value", "Voici en quelques mots le détail du projet:")

				//Inputs
				ddService.classList.add("tt-input-2")

				formStep++


			}else if(ddSujet.value === "Planifier une rencontre"){

				//Texts
				tt1.setAttribute("data-new-value", "avec")
				tt2.setAttribute("data-new-value", "Je désire une rencontre pour discuter de:")

				//Inputs
				ddContact.classList.add("tt-input-2")

				formStep++

			}else if(ddSujet.value === "Obtenir une consultation stratégique"){

				tt2.setAttribute("data-new-value", "Mes objectifs sont:")

				lastStep = 6
				formStep = 4

			}else if(ddSujet.value === "Proposer mes services"){

				//Texts
				tt1.setAttribute("data-new-value", "à titre de")
				tt2.setAttribute("data-new-value", "J’aimerais collaborer avec votre agence parce que:")

				//Inputs
				ddPostePigiste.classList.add("tt-input-2")

				formStep++

			}else if(ddSujet.value === "Soumettre ma candidature"){

				//Texts
				tt1.setAttribute("data-new-value", "pour le poste de")
				tt2.setAttribute("data-new-value", "Vous devriez considérer ma candidature parce que:")


				//Inputs
				ddPosteDispo.classList.add("tt-input-2")

				formStep++

			}else if(ddSujet.value === "Poser une question"){

				//Texts
				tt2.setAttribute("data-new-value", "Vous pouvez nous poser votre question:")

				lastStep = 6
				formStep = 4
			} else if(ddSujet.value === "Être accompagné pour la Loi 25"){

				//Texts
				tt2.setAttribute("data-new-value", "Apportez des précisions:")

				lastStep = 6
				formStep = 4
			}

			document.querySelector(".form-step-" + formStep)?.style.setProperty("display", "block");
			startTyping(formStep);

		})

		ddService?.addEventListener("change", (e) => {
			if(formStep<=2) {
				formStep = 4;
				document.querySelector(".form-step-" + formStep)?.style.setProperty("display", "block");
				startTyping(formStep);

				/*formStep = 5;
				document.querySelector(".form-step-" + formStep)?.style.setProperty("display", "block");
				startTyping(formStep);*/
			}
		})

		ddPosteDispo?.addEventListener("change", (e) => {
			if(formStep<=2){
				formStep++;
				document.querySelector(".form-step-" + formStep)?.style.setProperty("display", "block");
				startTyping(formStep);
			}

		})

		ddPostePigiste?.addEventListener("change", (e) => {
			if(formStep<=2){
				formStep = 5;
				document.querySelector(".form-step-" + formStep)?.style.setProperty("display", "block");
				startTyping(formStep);
			}

		})

		ddContact?.addEventListener("change", (e) => {

			if(formStep>2) {
				// Reset to contact step
				formStep = 2;
				document.querySelectorAll(".form-step-4, .form-step-5, .form-step-7, .form-step-8")?.forEach((el, index)=> {
					el.style.setProperty("display", "none");
				})
				document.querySelector(".form-step-6").classList.remove("visible")

				document.querySelector(".form-step-4 .tt-input")?.classList.add("tt-input-4")
				document.querySelector(".tt-submit").classList.remove("visible")
				document.querySelector(".bobby-calendly-link")?.classList.remove("tt-input-4", "visible");
				document.querySelector(".valerie-calendly-link")?.classList.remove("tt-input-4", "visible");
				tt2.innerHTML = ""
			}

			if(ddContact.value === "Valérie Durand"){

				$.fancybox.open(document.querySelector("#popUpCalendly.val-calendly"))
				tt2.setAttribute("data-new-value", " ")
				
				//console.log(document.querySelector(".form-step-5 .tt-input"))
				document.querySelector(".form-step-4 .tt-input")?.classList.remove("tt-input-4")
				document.querySelector(".form-step-4 .tt-input")?.style.setProperty("display", "none")
				document.querySelector(".bobby-calendly-link")?.classList.remove("tt-input-4", "visible")
				document.querySelector(".valerie-calendly-link")?.classList.add("tt-input-4")

			}else/* if(ddContact.value === "Bobby-Joe Audet"){


				$.fancybox.open(document.querySelector("#popUpCalendly.bobby-calendly"))
				tt2.setAttribute("data-new-value", " ")

				//console.log(document.querySelector(".form-step-4 .tt-input"))
				document.querySelector(".form-step-4 .tt-input")?.classList.remove("tt-input-4")
				document.querySelector(".form-step-4 .tt-input")?.style.setProperty("display", "none");
				document.querySelector(".bobby-calendly-link")?.classList.add("tt-input-4");
				document.querySelector(".valerie-calendly-link")?.classList.remove("tt-input-4", "visible");

			}else*/{

				tt2.setAttribute("data-new-value", "Je désire une rencontre pour discuter de")
				document.querySelector(".form-step-4 .tt-input")?.classList.add("tt-input-4")
				document.querySelector(".form-step-4 .tt-input")?.style.setProperty("display", "block");
				document.querySelector(".bobby-calendly-link")?.classList.remove("tt-input-4");
				document.querySelector(".valerie-calendly-link")?.classList.remove("tt-input-4");

			}

			if(formStep<=2) {
				formStep = 4;
				tt3.innerHTML = ""
				document.querySelector(".form-step-" + formStep)?.style.setProperty("display", "block");
				startTyping(formStep);
			}

		})

		document.querySelectorAll(".tt-upload")?.forEach((el, index) => {
			el.addEventListener("change", (e) => {

				if(!e.currentTarget.value == "" && formStep <= 3){
					const uploadFileName = e.currentTarget.value;
					document.querySelector("#uploaded-file-name").innerText = uploadFileName.split("\\")[2]
					document.querySelector(".upload-placeholder strong").remove()
					formNextStep()
				}
			})
		})

		document.querySelectorAll("input.tt-input")?.forEach((el, index) => {
			el.addEventListener("keyup", (e) => {
				//console.log(formStep +"/" + parseInt(e.currentTarget.getAttribute("data-step")))
				if(formStep <= parseInt(e.currentTarget.getAttribute("data-step"))){
					clearInterval(intentTimer)
					if(!e.currentTarget.value == ""){

						intentTimer = setInterval(() => {
							formNextStep()
							clearInterval(intentTimer)
						}, 500)

					}
				}

			})
		})


		window.addEventListener("wheel", footer_form_trigger)

		if(isAnchor || window.innerWidth <= 1024){
			footer_form_trigger()
		}
	}

	if(window.location.href.includes("contact")){
		initFormFooter()
	}


	/* Ajout la classe au body pour modifier le BG du fancybox */

	if(window.location.href.includes("offre-emploi") || window.location.href.includes("carriere") || window.location.href.includes("notre-equipe") ){
		document.querySelector("body").classList.add("page-form-carriere")
	}else{
		document.querySelector("body").classList.remove("page-form-carriere")
	}


	if( window.location.href.includes("demande-de-soutien") || window.location.href.includes("loi-25-septembre") ){
		document.querySelector("body").classList.add("no-banner")
	}else{
		document.querySelector("body").classList.remove("no-banner")
	}


	/*
	* Menu
	*/

	let navTrigger = document.querySelector("#nav-trigger")
	let elemCollection = document.querySelectorAll('body, #megamenu, #header, #main, .social-links')

	const toggleMenu = (evt) => {
		if(navTrigger.classList.contains('active')){
			navTrigger.classList.remove('active')
			for(const elem of elemCollection){
				elem.classList.remove('active')
			}

		}else{
			navTrigger.classList.add('active')
			for(const elem of elemCollection){
				elem.classList.add('active')
			}

		}

	}

	const menuItemWithChild = document.querySelectorAll("li.menu-item-has-children")
	//console.log(menuItemWithChild)
	const toggleSubMenu = (evt) => {

		if(evt.currentTarget.classList.contains("over")){

			evt.currentTarget.classList.remove("over")

		}else{

			menuItemWithChild?.forEach((el, index) => {
				el.classList.remove("over")
			})

			evt.currentTarget.classList.add("over")

		}

	}


	menuItemWithChild?.forEach((el, index) => {

		el.addEventListener("click", toggleSubMenu)
	})




	/*
	* Menu item - Background switch
	*/

	let menuItemsElem = document.querySelectorAll(".menu-item span")
	let menuBg1 = document.querySelector("#menu-bg-1 source")
	let menuBg2 = document.querySelector("#menu-bg-2")
	let bgActif = 1


	const switchMenuBg = (e) => {

		const imgSrc = e.currentTarget.getAttribute("data-background")

		if(bgActif == 1){
			menuBg2.setAttribute("src", imgSrc)
			menuBg1.classList.remove("visible")
			menuBg2.classList.add("visible")
			bgActif = 2

		}else if(bgActif == 2){
			menuBg1.setAttribute("srcset", imgSrc)
			menuBg2.classList.remove("visible")
			menuBg1.classList.add("visible")
			bgActif = 1

		}


		//console.log(menuBg)
	}

	menuItemsElem?.forEach((el, index) => {
		el.innerHTML = el.innerHTML.replace("°", "<span class='degree'></span>")
		el.addEventListener("mouseover", switchMenuBg)
	})

	let navMenuItems = document.querySelectorAll(".menu-item a, .logo a")

	navMenuItems?.forEach((el, i) => {

		el.addEventListener("click", (e) => {
			//e.stopPropagation()

			navMenuItems?.forEach((item, index) => {

				if(item.parentElement.classList.contains("current-menu-item") || item.parentElement.classList.contains("current-menu-parent")){
					item.parentElement.classList.remove("current-menu-item", "current-menu-parent")
				}

			})

			e.currentTarget.parentElement.classList.add("current-menu-item")
		})
	})

	navTrigger?.addEventListener("click", toggleMenu)



/*
	const teamMembers = document.querySelectorAll(".team-member-block")
	const openLightbox = (e) => {

		let team_member_id = e.currentTarget.getAttribute("data-id")
		let data = {
			'action': 'ajax_view_team_block',
			'team_member_id': team_member_id
		}

		fetch(window.ajax_url, {
			method: 'POST',
			credentials: 'same-origin',
			body:  new URLSearchParams(data)
		})
			.then(validateResponse)
			.then(success)
			.catch(logError);
	}

	const success = (response) => {
		const parser = new DOMParser();
		const data = parser.parseFromString(response.text(), 'text/html')
		console.log(data)
		$.fancybox.open(data)
	}

	const validateResponse = (response) => {
		if(!response.ok){
			throw Error(response.statusText)
		}else{
			console.log(response);
		}
		return response;
	}

	const logError = (err) => {
		console.log(err)
	}*/


	/*- /menu -*/


	/*
	 * Faux contact form URL manipulating
	 */
	$('body').on('click', 'a', function(e){
		let this_url = $(this).attr('href');

		if( ! this_url.includes(window.contact_form_url) ) return;

		e.preventDefault();

		$(location).attr('href', $(location).attr('href') + "#footer");
	});

	$('.chosen').chosen();





	/*-------------------------------------------------------------------------------------------------*/
	/*- jQuery stuff -*/
	/*-------------------------------------------------------------------------------------------------*/

	$(window).load(function(){
		AOS.init({
			once: true
		});
	})

	/*
	 * AJAX forms
	 */
	function handle_form(form, _callback)
	{
		form.addClass('loading');
		form.removeClass('errors');

		// Build the form data
		var form_data = new FormData();
		form_data.append('action', form.data('action'));

		form.serializeArray().reduce(function(obj, item) {
			form_data.append(item.name, item.value);
		}, {});

		// If the form contains files, add them to the form data
		if(form.find('input[type="file"]').length){
			var file_fields = form.find('input[type="file"]');

			$.each(file_fields, function(index, element){
				if( $(element).get(0).files.length !== 0) {
					var field_name = $(element).attr('name');

					form_data.append(field_name, $(element)[0].files[0]);
				}
			});
		}

		// AJAX request
		$.ajax({
			url: window.ajax_url,
			data: form_data,
			type: "POST",
			processData: false,
			contentType: false,
			success: function (r, textStatus, jqXHR) {

				if(r.success){

					_callback(r);

				} else {
					$('#succes-message *').remove()
					$('#error-message ul').remove()
					$('#error-message').append(r.data)
					$('#error-message').show()

				}
			}
		});
	}

})(jQuery);